// 基础css
import '__PUBLIC__/css/normalize.css'
import '__PUBLIC__/css/reset.scss'
import '__PUBLIC__/css/header.scss'
import '__PUBLIC__/css/footer.scss'
import '__PUBLIC__/css/nav.scss'

// 对JQuery 进行扩展
import '__PUBLIC__/js/util'
import '__PUBLIC__/js/ajaxPrefilter'

/**引入一些页面组件 **/

// 页面右侧在线客服咨询
import nav from 'html-loader!__COMPONENTS__/nav.html'
$('body').append(nav)

//头部js的引用
import '__PUBLIC__/js/header'
import '__PUBLIC__/js/nav'
import '__PUBLIC__/js/footer'
import '__PUBLIC__/js/tongji'
